export default __webpack_public_path__ + "static/media/share-tt.64a9291f.jpg";